document.addEventListener('click', function (e) {
  var wrapper = e.target.closest('.wrapper');
  if (!wrapper) return;

  // Tabs principales
  var mainBtn = e.target.closest('.tab-nav > .tab-btn');
  if (mainBtn) {
    var tabsOuter = mainBtn.closest('.tabs-outer');
    var name = mainBtn.getAttribute('data-panel');
    var panel = tabsOuter.querySelector('.tab-panel[data-panel="' + name + '"]');

    tabsOuter.querySelectorAll('.tab-nav > .tab-btn').forEach(function (b) {
      b.classList.remove('active');
    });
    tabsOuter.querySelectorAll(':scope > .tab-panel').forEach(function (p) {
      p.classList.remove('active');
    });

    mainBtn.classList.add('active');
    if (panel) panel.classList.add('active');
    return;
  }

  // Tabs internos CM / IN
  var innerBtn = e.target.closest('.inner-nav > .inner-btn');
  if (innerBtn) {
    var tabsInner = innerBtn.closest('.tabs-inner');
    var innerName = innerBtn.getAttribute('data-panel');
    var innerPanel = tabsInner.querySelector('.inner-panel[data-panel="' + innerName + '"]');

    tabsInner.querySelectorAll('.inner-nav > .inner-btn').forEach(function (b) {
      b.classList.remove('active');
    });
    tabsInner.querySelectorAll(':scope > .inner-panel').forEach(function (p) {
      p.classList.remove('active');
    });

    innerBtn.classList.add('active');
    if (innerPanel) innerPanel.classList.add('active');
  }
});